// extracted by mini-css-extract-plugin
module.exports = {"loader":"App_loader__QZOiq","error":"App_error__23zR6"};